export const ApiParamLabels = Object.freeze({
    type: 'Type',
    description: 'Description',
    categoryIds: 'Categories',
    vendor: 'Vendor',
});
